import { createSlice } from "@reduxjs/toolkit";

export const expensesSlice = createSlice({
  name: "expenses",
  initialState: {
    expenses: [],
    categories: [],
    filters: {},
    page: 1,
    pagy: { next: true },
    expensesListData: null,
    useMonth: false,
    loading: true,
    addExpenseModalOpen: false,
    currentExpense: null,
    month: `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
    selectedModal: null,
    search: "",
    view: "list",
    chartType: "pie",
  },
  reducers: {
    addExpense: (state, action) => {
      state.expenses.unshift(action.payload);
    },
    addExpenses: (state, action) => {
      state.expenses = [...state.expenses, ...action.payload];
    },
    setExpensesListData: (state, action) => {
      state.expensesListData = action.payload;
      state.useMonth = action.payload?.kind === "monthly";
    },
    setExpenses: (state, action) => {
      state.expenses = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPagy: (state, action) => {
      state.pagy = action.payload;
    },
    setMonth: (state, action) => {
      state.month = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAddExpenseModalOpen: (state, action) => {
      state.addExpenseModalOpen = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setCurrentExpense: (state, action) => {
      if (!action.payload) {
        state.currentExpense = null;
        return;
      }
      const expense = state.expenses.find(
        (expense) => expense.id === action.payload
      );

      state.currentExpense = expense;
    },
    setSelectedModal: (state, action) => {
      state.selectedModal = action.payload;
    },
    setFilters: (state, action) => {
      const { month } = action.payload;
      state.month = month;
      state.filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = {};
      state.month = `${new Date().getFullYear()}-${new Date().getMonth() + 1}`;
      state.search = "";
      state.view = "list";
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1; // Reset page when searching
    },
    setView: (state, action) => {
      state.view = action.payload;
    },
    setChartType: (state, action) => {
      state.chartType = action.payload;
    },
    updateExpensesList: (state, action) => {
      state.expensesListData = action.payload;
    },
    deleteExpensesList: (state) => {
      state.expensesListData = null;
    },
    updateExpensesListTotal: (state, action) => {
      state.expensesListData.formatted_total_balance = action.payload;
    },
    updateExpense: (state, action) => {
      const index = state.expenses.findIndex(
        (expense) => expense.id === action.payload.id
      );
      if (index !== -1) {
        state.expenses[index] = action.payload;
      }
    },
    deleteExpense: (state, action) => {
      const { id } = action.payload;
      const index = state.expenses.findIndex((expense) => expense.id === id);
      if (index !== -1) {
        state.expenses.splice(index, 1);
      }
    },
  },
});

export const {
  addExpense,
  addExpenses,
  setExpensesListData,
  setExpenses,
  setPage,
  setPagy,
  setMonth,
  setLoading,
  setAddExpenseModalOpen,
  setCategories,
  setCurrentExpense,
  setSelectedModal,
  setFilters,
  resetFilters,
  setSearch,
  setView,
  setChartType,
  updateExpensesList,
  updateExpensesListTotal,
  updateExpense,
  deleteExpense,
  deleteExpensesList,
} = expensesSlice.actions;

export default expensesSlice.reducer;
